<template>
  <div class="w-full container-padding lg:container-padding-lg text-center" data-component="CorporateGrowSubhomeHero">
    <div class="mx-auto pt-12 pb-20 md:pt-0 md:pb-0">
      <h1
        v-if="heroTitle"
        class="relative inline-block font-bold lowercase text-primary-100 text-[100px] leading-[1] [text-box-trim:trim-both] [text-box-edge:cap_text] md:text-[clamp(4rem,18vw,14rem)]">
        {{ heroTitle }}

        <!-- Mobiel: kleinere lijn, rechtsboven naast de titel. -->
        <span
          class="pointer-events-none absolute left-[80%] -top-4 -translate-y-1/2 md:hidden"
          aria-hidden="true">
          <span class="relative block w-9">
            <svg
              class="block h-auto w-full"
              width="38"
              height="37"
              viewBox="0 0 38 37"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.43646 35.0332C16.3738 32.9696 24.3113 12.7456 21.4222 7.79278C19.0303 3.69229 12.5228 -0.874629 7.38924 1.60178C3.17583 3.63432 -1.77308 9.84311 2.43647 15.222C9.86564 24.7149 36.7954 10.85 36.7954 10.85"
                stroke="#C9B99F"
                stroke-width="2"
                stroke-dasharray="4 4" />
            </svg>

            <AirplaneIcon
              class="absolute right-0 top-[10%] h-auto w-5 -translate-y-1/2 translate-x-1/3" />
          </span>
        </span>

        <!-- Desktop: grotere lijn, verticaal naast de titel. -->
        <span
          class="pointer-events-none absolute left-full ml-2 top-[45%] hidden -translate-y-1/2 md:block"
          aria-hidden="true">
          <span class="relative block md:w-14 lg:w-16">
            <svg
              class="block h-auto w-full"
              width="71"
              height="68"
              viewBox="0 0 71 68"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.09521 66.9629C31.03 62.9747 46.3697 23.8907 40.7863 14.3191C36.1637 6.39466 23.5876 -2.43119 13.6668 2.35462C5.52407 6.28264 -4.03998 18.2815 4.09522 28.6765C18.4526 47.0221 70.4959 20.2274 70.4959 20.2274"
                stroke="#C9B99F"
                stroke-width="2"
                stroke-dasharray="4 4" />
            </svg>

            <AirplaneIcon
              class="absolute -right-8 top-3 h-auto w-8 -translate-y-1/2 translate-x-1/3 lg:w-11" />
          </span>
        </span>
      </h1>

      <Typography
        v-if="heroSubTitle"
        as="p"
        variant="header-3"
        class="text-balance mt-4 lg:mt-0">
        {{ heroSubTitle }}
      </Typography>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { GrowSubHomeHeaderApiModel } from '@gro-up/api/corporate'
import { AirplaneIcon } from '@gro-up/ui/icons'
import { Typography } from '@gro-up/ui/primitives'

defineProps<GrowSubHomeHeaderApiModel>()
</script>
